import { cn } from '@theprintbar/shared';
import { HTMLAttributes, forwardRef } from 'react';
import { ButtonSize, ButtonVariant, defaultButtonClasses, getButtonIconSize } from '.';
import { CustomSVG } from '../..';
import { Spinner } from '../Spinner';

interface ImitationButtonProps extends HTMLAttributes<HTMLDivElement> {
	icon?: CustomSVG;
	iconClass?: string;
	circle?: boolean;
	spinner?: boolean;
	variant?: ButtonVariant;
	size?: ButtonSize;
	iconSize?: ButtonSize;
	disabled?: boolean;
}

export const ImitationButton = ({
	children,
	variant = ButtonVariant.primary,
	size = ButtonSize.M,
	iconSize,
	spinner,
	icon: Icon,
	iconClass,
	circle,
	className,
	disabled,
	...props
}: ImitationButtonProps) => (
	<div
		className={cn(
			defaultButtonClasses,
			variant,
			circle ? 'p-2' : size,
			className,
			disabled && 'text-grey opacity-50 pointer-events-none transition-all duration-500',
		)}
		aria-disabled={disabled}
		{...props}
	>
		{spinner ? <Spinner className={getButtonIconSize(iconSize || size)} /> : children}
		{Icon && (
			<Icon
				className={cn(
					spinner && 'opacity-0',
					!circle && (size !== ButtonSize.L ? 'ml-1' : 'ml-2'),
					getButtonIconSize(iconSize || size),
					iconClass,
				)}
				aria-hidden="true"
			/>
		)}
	</div>
);

export const PrimaryImitationButton = (props: ImitationButtonProps) => <ImitationButton {...props} variant={ButtonVariant.primary} />;
export const OutlineImitationButton = (props: ImitationButtonProps) => <ImitationButton {...props} variant={ButtonVariant.outline} />;

export const TransparentImitationButton = (props: ImitationButtonProps) => (
	<ImitationButton {...props} variant={ButtonVariant.transparent} />
);

export const ColouredImitationButton = (props: ImitationButtonProps) => <ImitationButton {...props} variant={ButtonVariant.coloured} />;
